import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4192e8a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-2 mb-3" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mt-2 mb-2" }, "Jobs", -1))
const _hoisted_3 = {
  key: 0,
  class: "bi bi-info-circle-fill text-info ms-2"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  if: "item.percentUniverseMaxCount"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}, "No", -1))
const _hoisted_11 = { class: "border-bottom mb-3" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", { class: "reset" }, "Specify Incident Universe ", -1))
const _hoisted_13 = { class: "mb-3 row" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "disabledTextInput",
  class: "col-form-label col-sm-3"
}, "Date Range: ", -1))
const _hoisted_15 = { class: "col-sm-9" }
const _hoisted_16 = { class: "col-form-label" }
const _hoisted_17 = { class: "mb-3" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "disabledTextInput",
  class: "form-label col-sm-3"
}, "Incident Types: ", -1))
const _hoisted_20 = { class: "col-sm-9" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-3" }
const _hoisted_23 = { class: "form-check" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "groupA"
}, " Group A ", -1))
const _hoisted_25 = { class: "col-3" }
const _hoisted_26 = { class: "form-check" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "groupB"
}, " Group B ", -1))
const _hoisted_28 = { class: "mb-3 mt-3 row" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "offenseTypes",
    class: "col-form-label d-block"
  }, "Offense(s):"),
  /*#__PURE__*/_createElementVNode("small", null, "Select one or more offenses, or leave blank for all")
], -1))
const _hoisted_30 = { class: "col-sm-9" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = ["value"]
const _hoisted_33 = { class: "border-bottom mb-3" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", { class: "reset" }, "Random Selection from Universe ", -1))
const _hoisted_35 = { class: "container" }
const _hoisted_36 = { class: "row mb-3 align-items-center" }
const _hoisted_37 = { class: "col-md-3 form-check" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "measureTypeNumber"
}, " Fixed count of incidents: ", -1))
const _hoisted_39 = { class: "col-sm-4" }
const _hoisted_40 = { class: "row mb-3 align-items-center" }
const _hoisted_41 = { class: "col-md-3 form-check" }
const _hoisted_42 = { class: "" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "measureTypePercent"
}, " Percent of universe: ", -1))
const _hoisted_44 = { class: "col-sm-4" }
const _hoisted_45 = { class: "input-group" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "%", -1))
const _hoisted_47 = { class: "row mb-3" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-end" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "percentUniverseMinCount",
    class: "col-form-label"
  }, "Min Count:")
], -1))
const _hoisted_49 = { class: "col-sm-4" }
const _hoisted_50 = { class: "row mb-3" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-end" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "percentUniverseMaxCount",
    class: "col-form-label"
  }, "Max Count:")
], -1))
const _hoisted_52 = { class: "col-sm-4" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-grid gap-2 d-md-flex justify-content-md-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
  }, "Cancel"),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-primary",
    type: "submit"
  }, "Save")
], -1))

import BTable from "../BTable/BTable.vue";

import { BTableOptions, BTableColumn } from "../BTable/BTable.types";
import TextInput from "../Fields/TextInput.vue";
import InformationModal from "../Misc/InformationModal.vue";
import { computed, onMounted, reactive, ref, watch } from "vue";
import { useOffenseStore } from "@/stores/offenseStore";
import { useAuditJobStore } from "@/stores/auditJobStore";
import { AuditJobCreate, Audit } from "@/audit.types";
import { debounce } from "vue-debounce";
import { number, object } from "yup";
import { useFormValidation } from "../../validation";


export default /*#__PURE__*/_defineComponent({
  __name: 'AuditJobs',
  props: {
    id: {},
    audit: {},
    runAudits: { type: Boolean },
    createAudits: { type: Boolean }
  },
  setup(__props: any) {

var updateData = debounce(() => getData(), "15000ms");

const auditJob = ref<AuditJobCreate>({
    auditId: null,
    incidentTypes: [],
    offenseTypes: [],
    sampleSize: null,
    measureType: 0,
    percentUniverse: null,
    percentUniverseMinCount: null,
    percentUniverseMaxCount: null,
} as AuditJobCreate);

const schema = object<AuditJobCreate>({
    sampleSize: number()
        .nullable()
        .transform((value) => (isNaN(value) ? undefined : value))
        .when("measureType", {
            is: 0,
            then: (schema) => {
                return schema.required();
            },
        })
        .label("Sample Size"),
    percentUniverse: number()
        .nullable()
        .transform((value) => (isNaN(value) ? undefined : value))
        .when("measureType", {
            is: 1,
            then: (schema) => {
                return schema.required();
            },
        })
        .label("Percent of Universe"),
    percentUniverseMinCount: number()
        .nullable()
        .transform((value) => (isNaN(value) ? undefined : value))
        .label("Min Count"),
    percentUniverseMaxCount: number()
        .nullable()
        .transform((value) => (isNaN(value) ? undefined : value))
        .when("measureType", {
            is: 1,
            then: (schema) => {
                return schema.required();
            },
        })
        .when("percentUniverseMinCount", ([percentUniverseMinCount], schema) =>
            percentUniverseMinCount > 0
                ? schema.moreThan(auditJob.value.percentUniverseMinCount!)
                : schema
        )
        .label("Max Count"),
});

const date = ref();

watch(
    () => auditJob.value.incidentTypes,
    async (newQuestion, oldQuestion) => {
        await offenseStore.list(auditJob.value.incidentTypes.join(","));
    }
);

const auditJobStore = useAuditJobStore();
const offenseStore = useOffenseStore();
const selectedId = ref(0);

const confirmDialog = ref(null);
const props = __props;

const canSelectIncidents = computed(
    () => props.runAudits && props.audit.status != "Closed"
);
const canDelete = function (item) {
    return item.status == "Queued";
};

const columns = reactive<BTableColumn[]>([
    {
        key: "id",
        text: "Job #",
        sortable: true,
        value: (item) => item["id"],
    },
    {
        key: "status",
        text: "Status",
        sortable: true,
        value: (item) => item["status"],
    },
    {
        key: "incidentTypes",
        text: "Incident Groups",
        sortable: true,
        value: (item) => item["incidentTypes"],
    },
    {
        key: "offenseTypes",
        text: "Offense",
        sortable: true,
        value: (item) => item["offenseTypes"],
    },
    {
        key: "sampleSize",
        text: "Sample Size",
        sortable: true,
        value: (item) => item["sampleSize"],
    },
    {
        key: "incidentsCount",
        text: "Incidents Selected",
        sortable: true,
        value: (item) => item["incidentsCount"],
    },
    {
        key: "actions",
        text: "",
        sortable: true,
        value: (item) => 2,
    },
]);

const { handleSubmit, errors } = useFormValidation();

const createJob = async function () {
    if (await handleSubmit(schema, auditJob.value)) {
        auditJob.value.auditId = props.id;
        await auditJobStore.create(auditJob.value);
        hideCreateEditor();
        await getData();

        date.value = [];
        auditJob.value = {
            sampleSize: null,
            incidentTypes: [],
            offenseTypes: [],
            measureType: 0,
        } as unknown as AuditJobCreate;
    }
};

const isShowCreateEditor = ref(false);
const showCreateEditor = function () {
    date.value = "";
    isShowCreateEditor.value = true;
};
const hideCreateEditor = function () {
    isShowCreateEditor.value = false;
};

const runJob = async function (id: number) {
    await auditJobStore.run(id);
};

const handleOptionChange = function (options: BTableOptions) {
    if (options) {
        auditJobStore.tableOptions = options;
    }
};

const isConfirmDialog = ref(false);

const deleteJob = async function () {
    auditJobStore.deleteItem(selectedId.value);
    hideConfirmEditor();
    await getData();
};

const deleteJobConfirm = async function (id: number) {
    selectedId.value = id;
    isConfirmDialog.value = true;
};

const hideConfirmEditor = async function () {
    isConfirmDialog.value = false;
};

const getData = async function () {
    await auditJobStore.list(props.audit.id);
    await updateData();
};
onMounted(async () => {
    await getData();
});

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (canSelectIncidents.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (showCreateEditor()), ["prevent"]))
          }, "Select Incidents"))
        : _createCommentVNode("", true),
      _hoisted_2,
      _createVNode(BTable, {
        items: _unref(auditJobStore).items,
        columns: columns,
        value: _unref(auditJobStore).tableOptions,
        onOptionChange: handleOptionChange
      }, {
        "cell.incidentNumber": _withCtx(({ item, column }) => [
          _createElementVNode("span", null, _toDisplayString(item.incidentNumber), 1)
        ]),
        "cell.status": _withCtx(({ item, column }) => [
          _createElementVNode("span", null, _toDisplayString(item.status), 1),
          (item.comment)
            ? _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_3, null, 512)), [
                [_directive_tooltip, item.comment]
              ])
            : _createCommentVNode("", true)
        ]),
        "cell.sampleSize": _withCtx(({ item, column }) => [
          (item.sampleSize)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(item.sampleSize), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, [
                _createTextVNode(_toDisplayString(item.percentUniverse) + "% ", 1),
                (item.percentUniverseMinCount&&item.percentUniverseMaxCount)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, " (" + _toDisplayString(item.percentUniverseMinCount) + "-" + _toDisplayString(item.percentUniverseMaxCount) + " incidents)", 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_7, " (" + _toDisplayString(item.percentUniverseMaxCount) + " incidents max)", 1))
              ]))
        ]),
        "cell.actions": _withCtx(({ item }) => [
          (canDelete(item))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: ($event: any) => (deleteJobConfirm(item.id)),
                type: "button",
                class: "btn btn-sm btn-danger"
              }, "Delete ", 8, _hoisted_8))
            : (_openBlock(), _createElementBlock("span", _hoisted_9))
        ]),
        _: 1
      }, 8, ["items", "columns", "value"])
    ]),
    _createVNode(InformationModal, {
      title: "Delete",
      key: "confirmDialog",
      ref_key: "confirmDialog",
      ref: confirmDialog,
      "show-modal": isConfirmDialog.value,
      "show-footer": true,
      className: "confirm",
      onDismiss: hideConfirmEditor
    }, {
      footer: _withCtx(() => [
        _hoisted_10,
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          onClick: _withModifiers(deleteJob, ["prevent"])
        }, "Yes")
      ]),
      default: _withCtx(() => [
        _createTextVNode(" Are You Sure? ")
      ]),
      _: 1
    }, 8, ["show-modal"]),
    _createVNode(InformationModal, {
      title: "Select Incidents",
      "show-modal": isShowCreateEditor.value,
      ref: "createDialog",
      onDismiss: hideCreateEditor
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _withModifiers(createJob, ["prevent"])
        }, [
          _createElementVNode("fieldset", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.audit.startMonth) + " to " + _toDisplayString(_ctx.audit.endMonth), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          value: "A",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((auditJob.value.incidentTypes) = $event)),
                          id: "groupA"
                        }, null, 512), [
                          [_vModelCheckbox, auditJob.value.incidentTypes]
                        ]),
                        _hoisted_24
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          value: "B",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((auditJob.value.incidentTypes) = $event)),
                          id: "groupB"
                        }, null, 512), [
                          [_vModelCheckbox, auditJob.value.incidentTypes]
                        ]),
                        _hoisted_27
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, [
                  _withDirectives(_createElementVNode("select", {
                    id: "offenseTypes",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((auditJob.value.offenseTypes) = $event)),
                    multiple: "",
                    disabled: auditJob.value.incidentTypes.length==0,
                    class: "form-select"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(offenseStore).items, (item) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: item.OffenseCode,
                        value: item.OffenseCode
                      }, _toDisplayString(item.OffenseLabel), 9, _hoisted_32))
                    }), 128))
                  ], 8, _hoisted_31), [
                    [_vModelSelect, auditJob.value.offenseTypes]
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("fieldset", _hoisted_33, [
            _hoisted_34,
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "measureType",
                    id: "measureTypeNumber",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((auditJob.value.measureType) = $event)),
                    value: 0
                  }, null, 512), [
                    [_vModelRadio, auditJob.value.measureType]
                  ]),
                  _hoisted_38
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createVNode(TextInput, {
                    modelValue: auditJob.value.sampleSize,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((auditJob.value.sampleSize) = $event)),
                    "aria-label": "Sample Size",
                    name: "sampleSize",
                    type: "number",
                    disabled: auditJob.value.measureType!=0,
                    id: "sampleSize",
                    class: "form-control",
                    error: _unref(errors).sampleSize
                  }, null, 8, ["modelValue", "disabled", "error"])
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "radio",
                      name: "measureType",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((auditJob.value.measureType) = $event)),
                      value: 1,
                      id: "measureTypePercent"
                    }, null, 512), [
                      [_vModelRadio, auditJob.value.measureType]
                    ]),
                    _hoisted_43
                  ])
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _createVNode(TextInput, {
                      modelValue: auditJob.value.percentUniverse,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((auditJob.value.percentUniverse) = $event)),
                      "aria-label": "Percent of universe",
                      name: "percentUniverse",
                      type: "number",
                      id: "percentUniverse",
                      class: "form-control",
                      disabled: auditJob.value.measureType!=1,
                      error: _unref(errors).percentUniverse
                    }, null, 8, ["modelValue", "disabled", "error"]),
                    _hoisted_46
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_47, [
                _hoisted_48,
                _createElementVNode("div", _hoisted_49, [
                  _createVNode(TextInput, {
                    type: "number",
                    modelValue: auditJob.value.percentUniverseMinCount,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((auditJob.value.percentUniverseMinCount) = $event)),
                    id: "percentUniverseMinCount",
                    disabled: auditJob.value.measureType!=1,
                    class: "form-control",
                    error: _unref(errors).percentUniverseMinCount
                  }, null, 8, ["modelValue", "disabled", "error"])
                ])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _hoisted_51,
                _createElementVNode("div", _hoisted_52, [
                  _createVNode(TextInput, {
                    type: "number",
                    modelValue: auditJob.value.percentUniverseMaxCount,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((auditJob.value.percentUniverseMaxCount) = $event)),
                    disabled: auditJob.value.measureType!=1,
                    id: "percentUniverseMaxCount",
                    class: "form-control",
                    error: _unref(errors).percentUniverseMaxCount
                  }, null, 8, ["modelValue", "disabled", "error"])
                ])
              ])
            ])
          ]),
          _hoisted_53
        ], 32)
      ]),
      _: 1
    }, 8, ["show-modal"])
  ], 64))
}
}

})